import { createSlice } from "@reduxjs/toolkit";

export const shareExperienceSlice = createSlice({
    name: 'shareExperience',
    initialState: {
        item: null,
        tag: null,
    },
    reducers: {
        setShareExperienceItem: (state, action) => {
            state.item = action.payload;
        },
        clearShareExperienceItem: (state) => {
            state.item = null;
        },
    }
});

export const { setShareExperienceItem, clearShareExperienceItem } = shareExperienceSlice.actions;
export default shareExperienceSlice.reducer;